function CHOOSE(index: number, ...args: number[]) {
  return args[index];
}

export default CHOOSE;
